import React from 'react';
import CancelIcon from '@material-ui/icons/Cancel';
import {filterValueParse, NavigationFilterValue} from '../domains/NavigationFilterService';
import {PAGE, PortalEnumNameToValue, ServiceLocationEnumNameToValue, SPLIT_DELIMITER} from 'placement/const';
import {ReferralPageAction} from "../reducers/referralPage";
import {formatDateStr} from "../../common/util/date";
import {subMonths} from "date-fns";

type Props = {
    filter: NavigationFilterValue,
    page: PAGE;
    dispatch: React.Dispatch<ReferralPageAction>,
}

export function FilterBadges({filter, dispatch, page}: Props) {
    const parse = filterValueParse(filter)
    let values: Array<string> = [];
    const escalationLevel = parse.escalationLevel ?
        parse.escalationLevel.map((i) => i.toString()) : []
    const serviceLocationTypes = parse.serviceLocationType ?? [];
    const counties = parse.counties ? parse.counties : [];

    values = values.concat(parse.serviceType ?? '');
    values = values.concat(parse.language ? parse.language : []);
    values = values.concat(parse.placementType ?? '');
    values = values.concat(parse.city ? parse.city : []);
    values = values.concat(parse.referralConsideration ?? '');
    values = values.concat(parse.matchedProvider ?? '');
    if (escalationLevel.length > 0) {
        values = values.concat([`Escalation levels: ${escalationLevel.join(', ')}`])
    }
    if (serviceLocationTypes.length > 0) {
        values = values.concat([`Service Location: ${serviceLocationTypes.map(st => ServiceLocationEnumNameToValue.get(st)).join(', ')}`])
    }
    if (counties.length > 0) {
        values = values.concat([`County: ${counties.join(', ')}`])
    }
    if (parse.referralSubmittedFrom) {
        values = values.concat([`Referral Submitted From: ${formatDateStr(parse.referralSubmittedFrom)}`])
    }
    if (parse.referralSubmittedTo) {
        values = values.concat([`Referral Submitted To: ${formatDateStr(parse.referralSubmittedTo)}`])
    }

    if (values.length === 0) {
        return <div/>;
    }

    const updateFilterByRemoveValue = (value: string) => {
        let shouldRemoveVal = PortalEnumNameToValue.get(value) ? PortalEnumNameToValue.get(value) : value;
        if (shouldRemoveVal) {
            const keyArr = [
                "serviceType",
                "provider",
                "requiredLanguage",
                "scopeOfService",
                "referralConsiderations",
                "preferredCity",
                "counties",
                "serviceLocationTypes",
                "escalationLevels",
                "referralSubmittedFrom",
                "referralSubmittedTo",
            ];
            for (let i = 0; i < keyArr.length; i++) {
                const key = keyArr[i] as keyof NavigationFilterValue;
                if (key === "escalationLevels" && shouldRemoveVal.includes("Escalation levels")) {
                    dispatch({type: 'SET_FILTER', filter: {...filter, escalationLevels: ""}});
                    return;
                }
                if (key === "serviceLocationTypes" && shouldRemoveVal.includes("Service Location")) {
                    dispatch({type: 'SET_FILTER', filter: {...filter, serviceLocationTypes: ""}});
                    return;
                }
                if (key === "counties" && shouldRemoveVal.includes("County")) {
                    dispatch({type: 'SET_FILTER', filter: {...filter, counties: ""}});
                    return;
                }
                if (key === "referralSubmittedFrom" && shouldRemoveVal.includes("Referral Submitted From:")) {
                    if (page === PAGE.OPEN_REFERRALS) {
                        dispatch({type: 'SET_FILTER', filter: {...filter, referralSubmittedFrom:  null}});
                    } else {
                        dispatch({type: 'SET_FILTER', filter: {...filter, referralSubmittedFrom:  subMonths(new Date(), 1)}});
                    }
                    return;
                }
                if (key === "referralSubmittedTo" && shouldRemoveVal.includes("Referral Submitted To:")) {
                    dispatch({type: 'SET_FILTER', filter: {...filter, referralSubmittedTo: null}});
                    return;
                }
                const val = filter[key] ?? "" ;
                const filterOptions = val.toString().split(SPLIT_DELIMITER);
                if (filterOptions.includes(shouldRemoveVal)) {
                    const newOptions = filterOptions.filter((val) => val !== shouldRemoveVal).join(SPLIT_DELIMITER);
                    let newFilter = {...filter};
                    if (key !== 'referralSubmittedTo' && key !== 'referralSubmittedFrom') {
                        newFilter[key] = newOptions;
                    }
                    dispatch({type: 'SET_FILTER', filter: newFilter});
                    return;
                }
            }
        }
    }

    return (
        <div className='flex pl-5 items-start'>
            <div className='pt-1 pr-5 flex-grow-0'>
                Filter:
            </div>
            <div className='flex flex-grow flex-wrap'>
                {
                    values.map((value) => (
                        <div key={value}
                             className='mr-2 mb-2 bg-botticelli-100 text-white p-2 rounded leading-none flex items-center'>
                            {PortalEnumNameToValue.get(value) ? PortalEnumNameToValue.get(value) : value}
                            <button className='bg-transparent outline-none focus:outline-none'
                                    onClick={() => updateFilterByRemoveValue(value)}>
                                <div
                                    className='bg-transparent text-white opacity-5 ml-3 outline-none focus:outline-none flex items-center'>
                                    <CancelIcon fontSize={"small"}/>
                                </div>
                            </button>
                        </div>
                    ))
                }
            </div>
        </div>);
}
